import { forwardRef, Inject, Injectable } from '@angular/core';
import { TranslateService }              from '@ngx-translate/core';
import { LegacyUibModalService }        from '../../app-lite/modals/legacy-uib-modal.service';

import VvGarageAddCustomerHtml from './vv-garage.add-customer.html'

import { MessagesService } from '../../app-lite/messages/messages.service';
import { ApiService }      from '../../app-lite/api/api.service';

export function VVGarageService (
  $uibModal: any,
  $translate: any,
  messages: any,
  workshopAPI: any
) {
  const VVGarage = function (customer: any) {
    this.customer            = customer;
    this.customer_first_name = this.customer.first_name || this.customer.contact_first;
    this.customer_last_name  = this.customer.last_name || this.customer.contact_last;
    this.customer_email      = this.customer.email || this.customer.contact_email;
    this.customer_mobile     = this.customer.mobile || '';
    this.vv_garage = {
      first_name: this.customer_first_name || '',
      last_name: this.customer_last_name || '',
      mobile: this.customer_mobile || '',
      email: this.customer_email || '',
      username: this.customer_email || '',
      customer_id: this.customer.id,
      vv_garage_customer_id: this.customer.vv_garage_customer_id
    };
  };

  VVGarage.prototype.add_customer = function () {
    const self = this;

    return $uibModal.open({
      templateUrl: VvGarageAddCustomerHtml,
      windowClass: 'lg-modal',
      controller: 'VVGarageAddCustomerCtrl',
      resolve: {
        VVGarage: function () {
          return self;
        }
      }
    }).result;
  };

  VVGarage.prototype.delete_customer = function () {
    const self = this;

    return workshopAPI.post('/vv_garage/delete_customer', this.vv_garage, 'vv_garage');
  };

  VVGarage.prototype.add_vehicle_to_customer = function(vehicle: any) {
    const self = this;

    return workshopAPI.post('/vv_garage/add_vehicle_to_customer', {
      vv_garage : self.vv_garage,
      vehicle: vehicle
    }, 'vv_garage');
  };

  VVGarage.prototype.delete_customer_vehicle = function(vehicle: any) {
    const self = this

    return workshopAPI.post('/vv_garage/delete_customer_vehicle', {
      vv_garage : self.vv_garage,
      vehicle: vehicle
    }, 'vv_garage');
  }

  return VVGarage;
}

@Injectable({ providedIn: 'root' })
export class VVGarageFactory {
  constructor (
    private $uibModal: LegacyUibModalService,
    private translateService: TranslateService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService
  ) {}

  create ( customer: any ): any {
    const Ctor = VVGarageService(
      this.$uibModal,
      this.translateService,
      this.messagesService,
      this.apiService
    );

    return new (Ctor as any)(customer);
  }
}
